import { defaultEmployerFormValues, EmployerFormValues } from "../common/EmployerFormValues";
import { defaultDisabilityFormValues, DisabilityFormValues } from "./DisabilityFormValues";
import { Frequency } from "../enums/Frequency";
import { DisabilityProduct } from "../enums/DisabilityProduct";
import { Taxation } from "../enums/Taxation";

export type DisabilityEmployerFormValues = EmployerFormValues & DisabilityFormValues & {
    phoneNumber: string,
    jobTitle: string,
    requiredSittingFrequency: Frequency,
    requiredStandingFrequency: Frequency,
    requiredWalkingFrequency: Frequency,
    requiredKeyboardingFrequency: Frequency,
    requiredFineManipulationFrequency: Frequency,
    requiredLiftingContinuouslyPounds: string,
    requiredLiftingFrequentlyPounds: string,
    requiredLiftingOccasionallyPounds: string,
    requiredTravelFrequency: string,
    hoursWorkedPerWeek: string,
    normalScheduleOnDateLastWorked: boolean,
    hoursWorkedOnDateLastWorked: string,
    dateReturnedToWork: string,
    returnToWork: string,
    workRelated: string,
    product: DisabilityProduct,
    baseWage: string,
    baseWageFrequency: string,
    baseWageEffectiveDate: string,
    employeeContributionPercentage: string,
    premiumTaxation: string,
    shortTermDisabilityEmployeeContributionPercentage: string,
    longTermDisabilityEmployeeContributionPercentage: string,
    shortTermDisabilityPremiumTaxation: Taxation,
    longTermDisabilityPremiumTaxation: Taxation,
    employeeOwnership: boolean,
    employeeOwnershipPercentage: string,
    bonusesOrCommissions: boolean,
    payAfterDateLastWorked: string,
    fullPayAfterDateLastWorked: string,
    payTypesAfterDateLastWorked: [{
        payType: string,
        startDate: string,
        endDate: string,
        totalHoursPaid: string,
        percentagePaid: string,
        estimateAmount: string,
        incorrectEstimate: boolean,
        amount: string
    }]
}

export const defaultDisabilityEmployerFormValues = {
    ...defaultEmployerFormValues,
    ...defaultDisabilityFormValues,
    phoneNumber: '',
    jobTitle: '',
    requiredSittingFrequency: '',
    requiredStandingFrequency: '',
    requiredWalkingFrequency: '',
    requiredKeyboardingFrequency: '',
    requiredFineManipulationFrequency: '',
    requiredLiftingContinuouslyPounds: '',
    requiredLiftingFrequentlyPounds: '',
    requiredLiftingOccasionallyPounds: '',
    requiredTravelFrequency: '',
    hoursWorkedPerWeek: '',
    normalScheduleOnDateLastWorked: true,
    hoursWorkedOnDateLastWorked: '',
    dateReturnedToWork: '',
    returnToWork: '',
    workRelated: '',
    product: '',
    baseWage: '',
    baseWageFrequency: '',
    baseWageEffectiveDate: '',
    employeeContributionPercentage: '',
    premiumTaxation: '',
    shortTermDisabilityEmployeeContributionPercentage: '',
    longTermDisabilityEmployeeContributionPercentage: '',
    shortTermDisabilityPremiumTaxation: '',
    longTermDisabilityPremiumTaxation: '',
    employeeOwnership: false,
    employeeOwnershipPercentage: '',
    bonusesOrCommissions: false,
    payAfterDateLastWorked: '',
    fullPayAfterDateLastWorked: '',
    payTypesAfterDateLastWorked: [{
        payType: '',
        startDate: '',
        endDate: '',
        totalHoursPaid: '',
        percentagePaid: '',
        estimateAmount: '',
        incorrectEstimate: false,
        amount: ''
    }]
}